import auth from '@/services/auth'
import { assumedOrgState } from '@/services/assumedOrg'
import { hasPolicyIqModule } from '@/constants'

export function policyIqFeatureFlags() {
  if (assumedOrgState.org) {
    return assumedOrgState.org.features_enabled || {}
  }
  const org = auth.getUserOrganization()
  return (org && org.features_enabled) ? org.features_enabled : {}
}

/** Platform staff (not View As) see every Policy IQ function. */
export function shouldShowPolicyIqModule(moduleKey) {
  if (auth.hasPlatformAccess() && !assumedOrgState.org) return true
  return hasPolicyIqModule(policyIqFeatureFlags(), moduleKey)
}
